import { useQuery } from '@tanstack/react-query';

import { getAdminRolePermissions } from '../../services/adminService';
import { TGetUserRoleSchema } from '@/types/admin-management/admin-roles-types';

// const useGetPermissions = (adminRoleId?: string, enabled: boolean = true) => {
const useGetPermissions = (
    adminRoles: Array<TGetUserRoleSchema> = [],
    enabled: boolean = true
) => {
    const {
        data,
        error,
        isFetching,
        isLoading,
        status,
        isError,
        refetch,
        isPending,
    } = useQuery({
        queryKey: ['admin-roles', adminRoles, 'permissions'],
        queryFn: () => getAdminRolePermissions(adminRoles!),
        refetchOnWindowFocus: true,
        enabled: adminRoles.length > 0 && !!enabled,
    });

    return {
        data,
        error,
        isFetching,
        isLoading,
        isError,
        status,
        refetch,
        isPending,
    };
};

export default useGetPermissions;
